import { BaseOtelLogProcessor } from '../BaseOtelLogProcessor';
/**
 * Log processor which uses a `TelemetrySink` provided by the Host to log events.
 * This means that the data that the Host added to their own `TelemetrySink` is going to be
 * respected in logs generated using this processor.
 * E.G. All the Otel PartA fields from the Host `TelemetrySink`.
 */
export class HostLogProcessor extends BaseOtelLogProcessor {
    constructor(hostTelemetrySink, audience, initialPersistentProps) {
        super(audience, initialPersistentProps);
        this.hostTelemetrySink = hostTelemetrySink;
        this.telemetryLogger.addSink(this.hostTelemetrySink);
    }
    /**
     * This is a no-op operation because this LogProcessor uses the host `TelemetrySink`, which doesn't implement `setUserContext`.
     */
    setUserContext(_userContext) { }
    /**
     * This is a no-op operation because this LogProcessor uses the host `TelemetrySink`, which is already loaded by the Host.
     */
    async loadFull() { }
}
// cspell:ignore otel, oteljs
//# sourceMappingURL=HostLogProcessor.js.map